import React, {Component} from "react";
import {
    FormGroup,
    ControlLabel,
    FormControl,
    Row,
    Col
}                         from "react-bootstrap";
import Select             from "react-select";
import                         "react-select/dist/react-select.css";

import {
  IS_VALID
}                         from "utils";

import Loader             from "../../Loader";
import JoditEditor from "../../generic/JoditEditor";

class Create extends Component {
    constructor (props) {
        super(props);

        this.editorRef;
    }

    render () {
        let {
            TierBlockMessage,
            actions
        } = this.props;

        let {
            isLoadingAction,

            title,
            browser,
            url,
            content,

            browserOptions
        } = TierBlockMessage;

        let requiredSpan = <span style={{ color: "red" }}>*</span>;

        return (
            <form>
                <Loader loading={isLoadingAction}/>
                <FormGroup>
                    <ControlLabel>Title {requiredSpan}</ControlLabel>
                    <FormControl
                        type="text"
                        placeholder="Enter Title..."
                        value={title}
                        onChange={(e) => {
                            actions.setValue({
                                title: e.target.value
                            });
                        }}
                    />
                </FormGroup>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>Browser</ControlLabel>
                            <Select
                                options={browserOptions}
                                value={browser}
                                onChange={(value) => {
                                    let stateToUpdate = {
                                        browser: value
                                    };

                                    if (!IS_VALID(value)) {
                                        stateToUpdate.url = "";
                                    }

                                    actions.setValue(stateToUpdate);
                                }}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>URL {requiredSpan}</ControlLabel>
                            <FormControl
                                disabled={!IS_VALID(browser)}
                                type="text"
                                placeholder="Enter Url..."
                                value={url}
                                onChange={(e) => {
                                    actions.setValue({
                                        url: e.target.value
                                    });
                                }}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <FormGroup>
                    <ControlLabel>Content {requiredSpan}</ControlLabel>
                    <JoditEditor
                        editorRef={(ref) => {
                            this.editorRef = ref;
                        }}
                        name="content"
                        value={content}
                        config={{
                            readonly: false,
                            globalFullSize: false
                        }}
                        onChange={(value) => {
                            actions.setValue({
                                content: value
                            });
                        }}
                    />
                </FormGroup>
            </form>
        );
    }
}

import {connect} from "react-redux";

function mapStateToProps(state) {
	let {
        TierBlockMessage
	} = state;

	return {
        TierBlockMessage
	};
}

export default connect(mapStateToProps)(Create);


// WEBPACK FOOTER //
// ./components/TierBlockMessage/FormContainer/Create.js